module.exports = __webpack_public_path__ + "static/media/logo2.29ee23e3.png";